import { render, staticRenderFns } from "./editDynamicData.vue?vue&type=template&id=4e071742"
import script from "./editDynamicData.vue?vue&type=script&lang=js"
export * from "./editDynamicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports